import { render, staticRenderFns } from "./BottomTimer.vue?vue&type=template&id=4b964117&scoped=true&lang=pug&"
import script from "./BottomTimer.vue?vue&type=script&lang=js&"
export * from "./BottomTimer.vue?vue&type=script&lang=js&"
import style0 from "./BottomTimer.vue?vue&type=style&index=0&id=4b964117&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b964117",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b964117')) {
      api.createRecord('4b964117', component.options)
    } else {
      api.reload('4b964117', component.options)
    }
    module.hot.accept("./BottomTimer.vue?vue&type=template&id=4b964117&scoped=true&lang=pug&", function () {
      api.rerender('4b964117', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/components/BottomTimer.vue"
export default component.exports